import { Card } from "@mui/material";
import i18n from "i18n/i18n";
import { useBoundStore } from "store/store";

function Werke() {

  const lang:any = useBoundStore((state) => state.lang);

  return (
    <Card className="initialCard">
        {i18n(lang)?.sites}
    </Card>
  );
}

export default Werke;
